import axios from 'axios'
//测试环境 http://39.155.223.185
//正式环境 http://rczxsamr.org.cn
const instance = axios.create({
    baseURL:' http://rczxsamr.org.cn/rcms_api',
    timeout:5000
})
instance.interceptors.request.use(config=>{
    //  // console.log('请求拦截');
    return config
},err=>{
    return Promise.reject(err)
})
instance.interceptors.response.use(res=>{
    //  // console.log('响应拦截');
    return res.data
},err=>{
    return Promise.reject(err)
})
export default instance